<template>
  <header class="header">
    <div class="header-left">
      <div class="logo-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
        </svg>
      </div>
      <div class="header-title">
        <h1>核对信息小程序</h1>
        <p>保护隐私、核对数据简单</p>
      </div>
    </div>
    <div class="header-right">
      <el-button @click="logout" type="text" class="logout-btn">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9"/>
        </svg>
        退出
      </el-button>
    </div>

    <!-- 修改资料弹窗 -->
    <el-dialog width="400px" :close-on-click-modal="false" title="修改用户资料" :visible.sync="editDialogVisible" custom-class="profile-dialog">
      <div class="form-row">
        <label>{{lable}}</label>
        <el-input v-model="content" autocomplete="off" placeholder="请输入内容" autofocus></el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cacelEdit">取 消</el-button>
        <el-button type="primary" @click="saveContent">保 存</el-button>
      </div>
    </el-dialog>
  </header>
</template>

<script>
export default {
  data() {
    return {
      username: '',
      name: '',
      school: '',
      content: '',
      lable: '',
      source: '',
      editDialogVisible: false,
      url: this.HOST_URL + '/images/logo.jpg'
    }
  },
  created() {
    this.username = this.$session.get('USERNAME')
    this.name = this.$session.get('NAME')
  },
  mounted() {
    if (this.isEmpty(this.username)) {
      this.$router.push('/')
    }
  },
  methods: {
    logout() {
      let that = this
      this.$confirm('要退出系统吗?', '提示', {
        confirmButtonText: '退出',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var requestUrl = '/checking/web/_logout.jsp'
        this.axios.get(requestUrl, {
          params: { username: that.username }
        }).then(function() {
          that.$session.set('USERNAME', '')
          that.$router.push('/')
        })
      }).catch(() => {})
    },
    editProfile(source) {
      if (source === 'school_name') {
        this.content = this.school
        this.lable = '学校'
        this.source = 'school_name'
      } else {
        this.content = this.teacher_name
        this.lable = '姓名'
        this.source = 'teacher_name'
      }
      this.editDialogVisible = true
    },
    cacelEdit() {
      this.editDialogVisible = false
    },
    saveContent() {
      if (this.content === '') {
        this.$message.error('内容不能为空！')
        return
      }
      let that = this
      var requestUrl = '/checking/web/_update_profile.jsp'
      if (this.source === 'school_name') {
        this.school = this.content
        that.$session.set('SCHOOL', this.content)
      } else {
        this.teacher_name = this.content
        that.$session.set('TEACHER_NAME', this.content)
      }
      this.axios.get(requestUrl, {
        params: {
          username: that.username,
          content: that.content,
          source: that.source
        }
      }).then(function() {
        that.content = ''
        that.editDialogVisible = false
        that.$message.success('修改成功！')
      })
    }
  }
}
</script>

<style scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
  height: 64px;
  background: #fff;
  border-bottom: 1px solid #e8ecf1;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.logo-icon {
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, #1485FB 0%, #0066CC 100%);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.logo-icon svg {
  width: 22px;
  height: 22px;
}

.header-title h1 {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0;
  line-height: 1.4;
}

.header-title p {
  font-size: 12px;
  color: #999;
  margin: 0;
  line-height: 1.4;
}

.logout-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #666;
  font-size: 14px;
  padding: 8px 16px;
  border-radius: 6px;
  transition: all 0.2s;
}

.logout-btn:hover {
  color: #1485FB;
  background: rgba(20, 133, 251, 0.08);
}

.logout-btn svg {
  width: 18px;
  height: 18px;
}

.form-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.form-row label {
  font-size: 14px;
  color: #666;
  white-space: nowrap;
  min-width: 50px;
}

.form-row >>> .el-input {
  flex: 1;
}

.profile-dialog >>> .el-dialog__header {
  background: linear-gradient(135deg, #1485FB 0%, #0066CC 100%);
  padding: 16px 20px;
}

.profile-dialog >>> .el-dialog__title {
  color: white;
  font-size: 16px;
  font-weight: 500;
}

.profile-dialog >>> .el-dialog__headerbtn .el-dialog__close {
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/head.vue